import { createApp } from 'vue'
import * as Sentry from "@sentry/react"
import "./main.css"

// Import Vue components
import VueApp from './src/vue/App.vue'

// Import Vue store, i18n, and router
import store from './src/vue/store'
import i18n from './src/vue/i18n'
import router from './src/vue/router'
import axios from "axios"

// Initialize Sentry
Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.NODE_ENV || 'development',
    release: process.env.NODE_ENV === 'production' 
        ? `production-${process.env.GITHUB_SHA || 'unknown'}`
        : process.env.NODE_ENV === 'staging'
            ? `staging-${process.env.GITHUB_SHA || 'unknown'}`
            : 'development',
    integrations: function (integrations) {
        return integrations.filter(function (integration) {
            return integration.name !== "BrowserSession";
        });
    },
    beforeSend(event) {
        if (
            event.exception?.values?.[0]?.value?.includes('isTrusted') ||
            event.message?.includes('NetworkError')
        ) {
            return null;
        }
        return event;
    },
});

// Set X-Tour-Host for all axios requests
axios.defaults.headers.common['X-Tour-Host'] = location.host;

// Create Vue app
const app = createApp(VueApp)

// Use plugins
app.use(router)
app.use(store)
app.use(i18n)

// Mount the app
app.mount('#root')

// Handle viewport height for mobile (iOS Safari friendly)
const setVh = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
};

setVh();
// Recalculate on resize, orientation change, and when returning from bfcache
window.addEventListener('resize', setVh);
window.addEventListener('orientationchange', setVh);
window.addEventListener('pageshow', (e) => {
    if (e.persisted) setVh();
});

console.log('Vue app started') 